<template>
  <v-layout fill-height v-if="homeScreenVisibility">
      
    <v-overlay opacity="0.7">
      <div class="mb-15" v-if="menuOption == 0">
        
        <v-row align="center" justify="center" style="position: relative; z-index: 100;">
          <v-col cols="auto">
             <v-img :eager="true" :transition="false" src="https://xpcwa.blob.core.windows.net/assets/MOWA_RGB_WITH_WM_WO.png" :width="logoWidth" contain>
            </v-img>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="auto">
            <v-card width="900px" class="font-weight-bold text-center" style="font-family:waHeadline; position: relative; z-index: 100;" color="transparent" flat >
              <span v-if="$vuetify.breakpoint.smAndDown" class="pl-2 pr-2" style="font-size:18px;">Get set to explore World Athletics artefacts from<br/> events around the world in stunning 360</span>
              <span v-else style="font-size:22px;" class="pl-2 pr-2">Get set to explore World Athletics artefacts from<br/> events around the world in stunning 360</span>
            </v-card>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="auto">
            <v-card width="900px" class="font-weight-bold text-center" style="position: relative; z-index: 100;" color="transparent" flat >
              <span v-if="$vuetify.breakpoint.smAndDown" class="pl-2 pr-2" style="font-size:18px;">With the support of Michael Burke<br/> Founding Patron of MOWA</span>
              <span v-else style="font-size:22px;" class="pl-2 pr-2">With the support of Michael H. Burke<br/> Founding Patron of MOWA</span>
            </v-card>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" class="pt-0" style="position: relative; z-index: 100;">
          <v-col cols="auto" class="pa-1">
            <v-btn :large="!$vuetify.breakpoint.smAndDown" color="#ff863b" light tile class="font-weight-bold" @click="OnSelectFreeRoam()">
              FREE ROAM
            </v-btn>
          </v-col>
          <v-col cols="auto" class="pa-1">
            <v-btn :large="!$vuetify.breakpoint.smAndDown" color="#a4f963" light tile class="font-weight-bold" @click="menuOption = 1">
              GUIDED TOUR
            </v-btn>
          </v-col>
        </v-row>

        <div class="banner" v-if="!kioskMode">
          <v-carousel
            cycle
            hide-delimiters
            show-arrows-on-hover
            max-width="600px"
            max-height="140px"
            height="auto"
          >
            <v-carousel-item
              v-for="(item, index) in items"
              :key="index"
              :src="item.src"
              contain
              @click="item.method"
              class="cursor-pointer"
              >
            </v-carousel-item>
          </v-carousel>
        </div>

      </div>
      <div v-else-if="menuOption == 1">
        <v-row align="center" justify="center">
          <v-col cols="12">
            
          </v-col>
          <v-col cols="auto">
            <v-card max-width="600px" class="font-weight-bold text-center headline" color="transparent" flat>
              <span>Select the area you are most interested in...</span>
            </v-card>
          </v-col>
         
        </v-row>
        <v-row align="center" justify="center" class="pt-2">
          <v-col cols="auto" v-if="!$vuetify.breakpoint.xsOnly">
            <v-btn icon text @click="menuOption=0">
              <v-icon x-large>
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="11" sm="auto"   class="pa-1">
              <v-select v-model="dropdownModel" :items="tours" return-object item-text="name" color="black" solo light hide-details="" :rounded="false" dense height="42px">

              </v-select>
          </v-col>
          <v-col cols="11" sm="auto" class="pa-1">
            <v-btn block large color="#ef864f" light tile class="font-weight-bold" height="42px" @click="OnSelectTour()">
              TAKE THE TOUR!
            </v-btn>
          </v-col>
          
          
        </v-row>
        <v-row align="center" justify="center">
           <v-col cols="auto" v-if="$vuetify.breakpoint.xsOnly">
            <v-btn icon text @click="menuOption=0">
              <v-icon x-large>
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-overlay>
    
    <!-- <div style="position:fixed;width:100%;bottom:0px;top:auto;z-index:15;" >
      <v-container>
      <v-row style="height:100%;position:relative;" justify="center">
        <v-col cols="12" md="12" xl="10">
          <v-card color="white" >
            <v-row class="pl-4 pr-4 pa-2" align="center" v-if="$vuetify.breakpoint.smAndDown" no-gutters >
              <v-col cols="8" class="pb-0">
                <span style="font-family:waHeadline;font-size:18px;color:#F18442">Win a Michael Johnson autographed running shoe</span>
                <br/>
              </v-col>
              <v-col cols="4">
                <v-card color="transparent" flat width="100%" height="50px">
                   <v-img style="position:absolute;top:-40px;bottom:-40px;left:0px;right:0px;"  src="https://xpcwa.blob.core.windows.net/assets/Shoes%20%2B%20Michael-Johnson.png" contain/>
                </v-card>
              </v-col>
              <v-col cols="12">
                <span style="font-family:waRegular;font-size:14px;">Entry Deadline Midnight 22 July 2022</span>
                <br/>
                <span style="font-size:8px;">Photo: ©Getty Images. Shoe was donated by Johnson’s former Athlete Representative Brad Hunt</span>
              </v-col>
              <v-col cols="12">
                <v-card hover @click="OnTapCompetition()" color="#a4f963" class="pa-2 font-weight-bold text-center" style="font-size:14px;user-selet:none;"  >
                   TAP HERE TO ENTER THE FREE PRIZE DRAW
                </v-card>
              </v-col>
            </v-row>
            <v-row class="pl-4 pr-4" align="center" v-else >
              <v-col cols="5" lg="5"  >
                <span style="font-family:waHeadline;font-size:20px;color:#F18442">Win a Michael Johnson autographed running shoe</span>
                <br/>
                <span style="font-family:waRegular;">Entry Deadline Midnight 22 July 2022</span>
                <br/>
                <span style="font-size:10px;">Photo: ©Getty Images. Shoe was donated by Johnson’s former Athlete Representative Brad Hunt</span>
              </v-col>
              <v-col cols="4">
                <v-card color="transparent" flat width="100%" height="80px">
                   <v-img style="position:absolute;top:-50px;bottom:-12px;left:0px;right:0px;"  src="https://xpcwa.blob.core.windows.net/assets/Shoes%20%2B%20Michael-Johnson.png" contain/>
                </v-card>
              </v-col>
              <v-col cols="3" lg="3">
                <v-card hover @click="OnTapCompetition()" color="#a4f963" class="pa-4 font-weight-bold" style="user-selet:none;">
                   CLICK HERE TO ENTER THE FREE PRIZE DRAW
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      </v-container>
    </div> -->
    
  </v-layout>
</template>

<script>
import {mapState,mapMutations, mapGetters, mapActions} from 'vuex'
  export default {
    name: 'MOWAEntry',
    components: {
    },
    props: {
    },
    computed: {

      ...mapState("sessionState", [
        "package",
        "homeScreenVisibility",
        "currentStage"
      ]),

      ...mapGetters("sessionState", [
        "CurrentStageData"
      ]),
      
      kioskMode ()
      {
        if(this.package != null)
        {
          if(this.package.settings != null)
          {
            if(this.package.settings.kioskMode)
              return true;
          }
        }

        return false;
      },

      logoWidth () 
      {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 270
          case 'sm': return 300
          case 'md': return 350
          case 'lg': return 400
          case 'xl': return 500
        }
      },

      tours () {
        return this.package.tours;
      }
    },

    mounted () {

      this.dropdownModel = this.package.tours[0];

    },
    data () {
      return {
        menuOption : 0,
        dropdownModel : 0,
        dropdowns : ["1","2"],
        hideIntro : false,
        items: [
            {
              src: '/assets/banner-comic.png',
              method: this.OnTapComicBookOrder
            }
          ],
        }
    },
    methods: {

      ...mapMutations("sessionState", [
        "SetActiveTour",
        "SetHomeScreenVisibility",
        "PlayAudio",
        "SetVideoGroupsToPlay",
        "SetForceLandRotation",
        "SetTouchpointToIndex",
        "SetForceShowTouchpoint",
        "SetForceShowAsset",
        "SetForceShowTab",
        "AddCustomSessionData",
        "ClearCustomSessionDataOfKey"
       
      ]),

      ...mapActions("sessionState", [
        "BeginTour"
      ]),

      OnSelectFreeRoam()
      {
        //this.SetVideoGroupsToPlay();
        this.PlayAudio();
        this.SetHomeScreenVisibility(false);
      },
      OnSelectTour()
      {
        //this.SetVideoGroupsToPlay();
        this.SetHomeScreenVisibility(false);
        this.BeginTour(this.dropdownModel);
      },
      OnTapCompetition()
      {
        this.SetForceShowTouchpoint(true);
        //this.SetForceShowAsset("192a0e4e-fbca-4660-8fef-e0350e8dfd88");
        this.SetForceShowTab("COMPETITION");
        this.SetForceLandRotation(true);
        var validTP = this.currentStage.typeData.touchpoints.find(tp => tp.name == "Touchpoint_2000");
        this.$emit("OnTouchpointTap",validTP.id);
        this.SetHomeScreenVisibility(false);
      },
      OnTapGlasgowCompetition()
      {
        this.ClearCustomSessionDataOfKey("glasgowCompetitionLanguage");
        this.SetForceShowTouchpoint(true);
        //this.SetForceShowAsset("aa0490ef-622b-4a27-a9fe-dff8f94ee8d8");
        this.SetForceShowTab("COMPETITION");
        this.SetForceLandRotation(true);
        var validTP = this.currentStage.typeData.touchpoints.find(tp => tp.name == "TP_IO_IndoorTimeline2016");
        this.$emit("OnTouchpointTap",validTP.id);
        this.SetHomeScreenVisibility(false);

      },
      OnTapGlasgowCompetitionHun()
      {
        this.ClearCustomSessionDataOfKey("glasgowCompetitionLanguage");
        this.AddCustomSessionData({key: "glasgowCompetitionLanguage", value : 1});
        this.SetForceShowTouchpoint(true);
        //this.SetForceShowAsset("aa0490ef-622b-4a27-a9fe-dff8f94ee8d8");
        this.SetForceShowTab("COMPETITION");
        this.SetForceLandRotation(true);
        var validTP = this.currentStage.typeData.touchpoints.find(tp => tp.name == "TP_IO_IndoorTimeline2016");
        this.$emit("OnTouchpointTap",validTP.id);
        this.SetHomeScreenVisibility(false);

      },
      OnTapGlasgowCompetition2024()
      {
        this.ClearCustomSessionDataOfKey("glasgowCompetitionLanguage");
        this.SetForceShowTouchpoint(true);
        //this.SetForceShowAsset("aa0490ef-622b-4a27-a9fe-dff8f94ee8d8");
        this.SetForceShowTab("COMPETITION");
        this.SetForceLandRotation(true);
        var validTP = this.currentStage.typeData.touchpoints.find(tp => tp.name == "TP_IO_IndoorTimeline2016");
        this.$emit("OnTouchpointTap",validTP.id);
        this.SetHomeScreenVisibility(false);
      },
      OnTapComicBookOrder()
      {
        // this.SetForceShowTouchpoint(true);
        // //this.SetForceShowAsset("18cfb267-3cc3-40a6-908a-0504a7000d15");
        // this.SetForceShowTab("COMPETITION");
        // this.SetForceLandRotation(true);
        // var validTP = this.currentStage.typeData.touchpoints.find(tp => tp.name == "Partner1 (1)");
        // this.$emit("OnTouchpointTap",validTP.id);
        // this.SetHomeScreenVisibility(false);

        // Temporary launch comic link directly.
        const url = 'https://iaafmedia.s3.amazonaws.com/magical-athletics-journey/index.html';
        window.open(url, '_blank');
      }
    },
    watch: {

      homeScreenVisibility : {

        handler(newVal)
        {
          this.menuOption = 0;
        }
      }
      
    }
  }
</script>

<style lang="scss">
.banner {
	position: fixed;
  margin: auto;
  max-width: 600px;
  // max-height: 140px;
  left: 0;
  right: 0;
	bottom: 0;

  @media (min-width: 600px) {
    bottom: 30px;
  }
  @media (max-height: 600px) {
    bottom: 0;
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>